<template>
  <v-col class="pa-6">
    <div v-if="!viewingRequest">
      
      <v-row class="mt-5 px-6" align="center">
        <v-col cols="12" md="3">
          <v-text-field class="input ma-0 pa-0" label="Search..." prepend-inner-icon="mdi-magnify" v-model="search"
            rounded :hide-details="true"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select style="max-width: 240px" class="input ma-0 pa-0" label="Status Type" v-model="selectedType"
              :items="statusTypes" rounded :hide-details="true" clearable></v-select>
          </v-row>
        </v-col>
      </v-row>


      <v-data-table
        class="elevation-1 mt-4 ml-4 mr-8"
        :items="filteredRefunds"
        :headers="headers"
        :search="search"
        >
        <template v-slot:item.action="{ item }">
            <td class="d-flex align-center">
            <v-icon color="#4390c0" class="mr-3" @click="viewRefund(item)">
                mdi-eye
            </v-icon>
            </td>
        </template>
        </v-data-table>

    </div>


    <div v-if="viewingRequest">
  <v-row justify="center">
    <v-row class="ma-2">
      <v-col cols="12" md="6">
        <v-row class="mb-2">
          <v-icon class="black-color" @click="close()">
            mdi-arrow-left
          </v-icon>
          <h4 class="grey-color mx-4" style="font-weight: 500">
            Refund Information
          </h4>
        </v-row>
      </v-col>
    </v-row>
  </v-row>
  <v-row justify="center">
    <div class="white-card pa-8">
      <v-row justify="start" class="ma-0">
        <h2 class="fs400 mb-4">Refund Info</h2>
        <v-chip class="status-chip mx-2 mt-1" style="text-transform: capitalize"
          :color="statusColor(selectedRequest.status || 'Pending')" dark>
          {{ selectedRequest.status || "Pending" }}
        </v-chip>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" md="6">
          <v-row justify="start">
            <v-col cols="12" md="6">
              <v-row justify="start">
                <p><strong>Date Requested:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-text-field readonly filled outlined dense rounded v-model="selectedRequest.requestedAtFormatted">
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="start">
            <v-col cols="12" md="6">
              <v-row justify="start">
                <p><strong>Client Email:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-text-field readonly filled outlined dense rounded v-model="selectedRequest.clientEmail">
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="start">
            <v-col cols="12" md="6">
              <v-row justify="start">
                <p><strong>Paid Amount:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-text-field readonly filled outlined dense rounded v-model="selectedRequest.paidAmount">
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="start">
            <v-col cols="12" md="6">
              <v-row justify="start">
                <p><strong>Refund Amount:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-text-field readonly filled outlined dense rounded v-model="selectedRequest.refundAmount">
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="start">
            <v-col cols="12" md="6">
              <v-row justify="start">
                <p><strong>Reason:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-text-field readonly filled outlined dense rounded v-model="selectedRequest.reason">
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>
          
          <v-row justify="start">
            <v-col cols="12" md="12">
              <v-row justify="start">
                <p><strong>Description:</strong></p>
              </v-row>
              <v-row justify="start">
                <v-textarea readonly filled outlined dense rounded v-model="selectedRequest.description" rows="2">
                </v-textarea>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6">
          <v-row justify="center" justify-md="start">
            <p><strong>Refund Status:</strong></p>
          </v-row>
          <v-row justify="center" justify-md="start">
            <v-select style="max-width: 240px" class="ma-0 pa-0" v-model="selectedRequest.status"
              :items="statusTypes" filled outlined dense rounded :hide-details="true"></v-select>
          </v-row>

          <v-row justify="center" justify-md="start" v-if="selectedRequest.status === 'denied'" class="mt-8">
            <v-textarea style="max-width: 240px" v-model="selectedRequest.reason" label="Reason for Denial"
              auto-grow outlined filled clearable rounded rows="2"
              :rules="[v => !!v || 'Reason is required']"></v-textarea>
          </v-row>

          <v-row justify="center" justify-md="start">
           <v-btn @click="updateStatus()" color="#e022d1" dark rounded width="240px" class="pink-btn mt-4">
              Update Status
            </v-btn>

          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-row>
</div>

   
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="black" dark depressed large style="border-radius: 24px" @click="promptDialog = false">
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { Browser } from '@capacitor/browser';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDoc, getFirestore, collection, getDocs, doc, updateDoc, Timestamp, query, where, increment } from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);


import { logAction, sendPushNotificationUser } from "@/utils/firestoreUtil";

export default {
data() {
  return {
    refunds: [],
    headers: [
      { text: "Refund ID", value: "id" },
      { text: "User", value: "userName" },
      { text: "Email", value: "clientEmail" },
      { text: "Paid Amount", value: "paidAmount" },
      { text: "Reason", value: "reason" },
      { text: "Date Requested", value: "requestedAtFormatted" },
      { text: "Status", value: "status" },
      { text: "Action", value: "action" },
    ],

    search: "",
    statusTypes: ["pending", "approved", "denied"],
    selectedType: "pending",
    requests: [],
    loading: false,
    promptDialog: false,
    promptType: "",      
    promptMessage: "",
    viewingRequest: false,
    selectedRequest: {},
  };
},

  async mounted() {
  this.getRefunds();
},

  methods: {
    async updateStatus() {
      if (!this.selectedRequest.status) return;

      try {
        this.loading = true;

        const refundRef = doc(db, "refundRequest", this.selectedRequest.id);

        await updateDoc(refundRef, {
          status: this.selectedRequest.status,
          reason: this.selectedRequest.status === "denied" ? this.selectedRequest.reason : "",
          updatedAt: Timestamp.now(),
        });

      
        if (this.selectedRequest.status === "approved") {
            const forfeitedAmount = Number(this.selectedRequest.forfeitedAmount || 0);

            // Create new wallet transaction
            await addDoc(collection(db, "wallet_transactions"), {
              amount: forfeitedAmount,
              createdAt: Timestamp.now(),
              updatedAt: Timestamp.now(),
              description: "Refund forfeited",
              type: "credit",
              status: "completed",

              metadata: {
                paymentType: "refund",
                paymentMethod: "wallet",
                paymentSource: "refund_request",
                referenceId: this.selectedRequest.id,
                refundRequestId: this.selectedRequest.id,
                userId: this.selectedRequest.clientID,
                userEmail: this.selectedRequest.clientEmail,
              },

              userId: this.selectedRequest.clientID,
              userEmail: this.selectedRequest.clientEmail,
            });

            // Update wallet balance
            const clientRef = doc(db, "clients", this.selectedRequest.clientID);
            await updateDoc(clientRef, {
              walletBalance: increment(forfeitedAmount),
              lastUpdated: Timestamp.now(),
            });
          }


        this.promptType = "success";
        this.promptMessage = "Refund status updated successfully!";
        this.promptDialog = true;

        await this.getRefunds();
        this.viewingRequest = false;

      } catch (error) {
        console.error("Error updating refund status:", error);
        this.promptType = "error";
        this.promptMessage = "Failed to update refund status.";
        this.promptDialog = true;

      } finally {
        this.loading = false;
      }
    },




     close() {
            this.viewingRequest = false;
            localStorage.removeItem('ViewedRequest');
        },
    viewRefund(item) {
      this.selectedRequest = {
        ...item,
        forfeitedAmount: Number(item.forfeitedAmount || 0)
      };
      this.viewingRequest = true;
    },



   async getRefunds() {
      try {
        this.loading = true;

        const q = query(collection(db, "refundRequest"));
        const querySnapshot = await getDocs(q);

       this.refunds = querySnapshot.docs.map(docSnap => {
          const data = docSnap.data();

          return {
            id: docSnap.id,
            userName: data.clientName || "Unknown",
            clientEmail: data.clientEmail || "-",
            clientID: data.clientID || "",
            doctorFullName: data.doctorFullName || "-",
            paidAmount: data.paidAmount || 0,
            refundAmount: data.refundAmount || 0,
            forfeitedAmount: data.forfeitedAmount || 0,
            description: data.description || "",
            reason: data.reason || "",
            requestedAt: data.requestedAt || null,
            requestedAtFormatted: data.requestedAt?.toDate?.().toLocaleDateString() || "-",
            status: data.status || "pending",
          };
        });


        this.loading = false;
      } catch (error) {
        console.error("Error loading refunds:", error);
        this.loading = false;
      }
    },

    statusColor(status) {
      switch (status) {
        case "denied":
          return "#e022d1";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        default:
          return "grey";
      }
    },
  },
computed: {
  filteredRefunds() {
    return this.refunds.filter(r => {
      const matchesSearch =
        r.userName.toLowerCase().includes(this.search.toLowerCase()) ||
        r.email.toLowerCase().includes(this.search.toLowerCase());

      const matchesStatus =
        !this.selectedType || r.status === this.selectedType;

      return matchesSearch && matchesStatus;
    });
  },
},

};
</script>

<style scoped>
.reason-field {
  background-color: #fafafa;
  border-radius: 12px;
}

.image {
  width: 200px;
  border: 2px solid grey;
}
</style>